import React from "react";
import PhoneNumberRenderer from "./PhoneNumberRenderer";
import { Accordion, Row, Col, Card } from "react-bootstrap";

interface PrivacyRendererPhoneState
{
    open: boolean;
}

export default class NormalRendererPhone extends React.Component<any, PrivacyRendererPhoneState>
{
    constructor(props: any)
    {
        super(props);

        this.state = {
            open: false
        };
    }

    render(): React.ReactNode
    {
        if (this.props.value.length > 1)
        {
            const primaryPhone = this.props.value.filter((itm: Phone) => itm.isPrimary)[0];

            return <Accordion className={"border-0"}>
                <Card className={"toggle-sm border-0"}>
                    <Accordion.Toggle as={"a"} variant="link" onClick={() => this.setState({ open: !this.state.open })} eventKey="0">
                        <Card.Header className={"border-0"}>
                            <Row>
                                <Col xs={10}>
                                    <div>
                                        <PhoneNumberRenderer value={primaryPhone.phoneNumber} />
                                    </div>
                                </Col>
                                <Col xs={2}>
                                    <i className={this.state.open ? "far fa-chevron-up" : "far fa-chevron-down"}></i>
                                </Col>
                            </Row>
                        </Card.Header>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="0">
                        <Card.Body>
                            <div>
                                <PhoneNumberRenderer value={this.props.value} />
                            </div>
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            </Accordion>;
        }

        return <div><PhoneNumberRenderer value={this.props.value} /></div>;
    }
}
